import DomFactory from '../../common/factory/factory';

export default class QuizDomFactory extends DomFactory {
  public createWrapper() {
    const quizContainer = document.createElement('div');
    quizContainer.classList.add('quiz-container');
    return quizContainer;
  }

  public createTitle(content: string) {
    const title = document.createElement('h3');
    title.classList.add('quiz-title');
    title.textContent = content;
    return title;
  }

  public createContent(content: string) {
    const contentElement = document.createElement('div');
    contentElement.classList.add('quiz-content');
    contentElement.innerHTML = content;
    return contentElement;
  }

  public createAlternativesContainer() {
    const alternativesContainer = document.createElement('div');
    alternativesContainer.classList.add('alternatives-container');
    return alternativesContainer;
  }
}
